import axios from 'axios';

// For local development: http://localhost:5134/api
// const API_BASE_URL = 'http://localhost:5134/api';
// For production: set REACT_APP_API_URL environment variable
// const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5134/api';
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://service.newjerseypla.org/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Events API
export const getActiveEvent = async () => {
  const response = await api.get('/events/active');
  // API returns Ok(activeEvent), so response.data is the event object
  return response.data;
};

export const getEventById = async (eventId) => {
  const response = await api.get(`/events/${eventId}`);
  return response.data;
};

// Teams API
export const getTeams = async (eventId) => {
  const response = await api.get(`/events/${eventId}/teams`);
  return response.data;
};

export const getAvailableTeams = async (eventId) => {
  const response = await api.get(`/events/${eventId}/teams/available`);
  return response.data;
};

// Registrations API
export const getAvailableSpots = async (eventId) => {
  const response = await api.get(`/events/${eventId}/spots/available`);
  return response.data;
};

export const createRegistration = async (registrationData) => {
  const response = await api.post('/registrations', registrationData);
  return response.data;
};

export const getRegistrations = async (eventId) => {
  const response = await api.get(`/events/${eventId}/registrations`);
  return response.data;
};

export const getRegistrationById = async (registrationId) => {
  const response = await api.get(`/registrations/${registrationId}`);
  return response.data;
};

export const updateRegistration = async (registrationId, registrationData) => {
  // Convert ID to number if it's a string (backend expects int)
  const id = typeof registrationId === 'string' ? parseInt(registrationId, 10) : registrationId;
  const response = await api.put(`/registrations/${id}`, registrationData);
  return response.data;
};

export const deleteRegistration = async (registrationId) => {
  // Convert ID to number if it's a string (backend expects int)
  const id = typeof registrationId === 'string' ? parseInt(registrationId, 10) : registrationId;
  const response = await api.delete(`/registrations/${id}`);
  return response.data;
};

// Admin API - Add player to team
export const addPlayerToTeam = async (teamId, playerData) => {
  // Convert ID to number if it's a string (backend expects int)
  const id = typeof teamId === 'string' ? parseInt(teamId, 10) : teamId;
  const response = await api.post(`/admin/teams/${id}/players`, playerData);
  return response.data;
};

// Payment API - MX Merchant (deprecated, kept for backward compatibility)
export const authorizeMxMerchantPayment = async (paymentData) => {
  const response = await api.post('/authorize-mxmerchant-payment', paymentData);
  return response.data;
};

// Stripe Payment API
export const createStripePaymentIntentFromToken = async (paymentData) => {
  const response = await api.post('/create-payment-intent-from-token', paymentData);
  return response.data;
};

export const createStripePaymentIntent = async (paymentData) => {
  const response = await api.post('/create-stripe-payment-intent', paymentData);
  return response.data;
};

export const confirmStripePayment = async (paymentData) => {
  const response = await api.post('/confirm-stripe-payment', paymentData);
  return response.data;
};

export const getStripePaymentIntentStatus = async (paymentIntentId) => {
  const response = await api.get(`/stripe-payment-intent/${paymentIntentId}`);
  return response.data;
};

export const captureStripePayment = async (paymentIntentId) => {
  const response = await api.post('/capture-stripe-payment', paymentIntentId);
  return response.data;
};

export const cancelStripePayment = async (paymentIntentId) => {
  const response = await api.post('/cancel-stripe-payment', paymentIntentId);
  return response.data;
};

// Auth API
export const login = async (username, password) => {
  const response = await api.post('/auth/login', {
    Username: username,
    Password: password,
  });
  return response.data;
};

export default api;

